import { render, staticRenderFns } from "./noteManageAdd.vue?vue&type=template&id=63c9bb40&scoped=true"
import script from "./noteManageAdd.vue?vue&type=script&lang=js"
export * from "./noteManageAdd.vue?vue&type=script&lang=js"
import style0 from "./noteManageAdd.vue?vue&type=style&index=0&id=63c9bb40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c9bb40",
  null
  
)

export default component.exports